export default __webpack_public_path__ + "static/media/partner-category-cover-image.4f61f65a.png";